/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  BiGitMerge,
  BiPencil,
  BiTrash,
  BiDotsHorizontalRounded,
} from "react-icons/bi";
import { FiLink2, FiDelete } from "react-icons/fi";
import { FaUnlink } from "react-icons/fa";
import { OverlayTrigger, Dropdown } from "react-bootstrap";
import Utils from "../../../../core/utilities/Utils";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import ConfirmationModal from "../../../../components/ConfirmationModal/ConfirmationModal";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import { useParams } from "react-router";

function RiskParameter({
  t,
  riskParams,
  handleEdit,
  handleChild,
  handleDelete,
  handleDatasourceLink,
}) {
  const [paramId, setParamId] = useState("");
  const [labelEnable, setLabelEnable] = useState("Disable");
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const [unlinkItem, setUnlinkItem] = useState("");
  const [confirmId, setConfirmId] = useState("");
  const { reg_id } = useParams();
  const { type } = useParams();
  const [riskParamss, setRiskParams] = useState([]);
  let data = JSON.parse(localStorage.getItem("authority"));


  useEffect(() => {
    // getRegulationDetails(reg_id)
  }, [reg_id])

  const getRegulationDetails = (id) => {
    RiskConfigService.getRegulationDetails(id, type)
      .then((response) => {
        var data = response.data.riskParams;
        console.log('dataaa', data)
        setRiskParams([...response.data.riskParams])
        // if (type === "REGULATION") {
        //   list.status = response.data.status;
        // }
        // var riskCateg = response.data.resultConfigs;
        // data
        //   ? setRiskParams([...response.data.riskParams])
        //   : setRiskParams([]);
        // riskCateg ? setRiskConfig(riskCateg) : setRiskConfig([]);
      })
      .catch((error) => {
      });
  };

  const editRiskParam = (id) => {
    setParamId(id);
    handleEdit(id);
  };
  const handleChildExpand = (id) => {
    handleChild(id);
  };
  const deleteRiskParam = (item) => {
    setConfirmId(1); // delete parameter
    if (item.children && item.children.length > 0) {
      setMessageConfirmation(t("ConfirmDeleteParentRiskMsg.label"));
    } else {
      setMessageConfirmation(t("ConfirmDeleteRiskMsg.label"));
    }

    setShow(true);
    setDeleteId(item);
  };
  const handleDataSource = (id, datasourceId = "") => {
    handleDatasourceLink("link", id, datasourceId);
  };
  const handleCallbackonfirmation = (val, id) => {
    setShow(false);
    if (id === 1) {
      val && handleDelete(deleteId);
    } else if (id === 2) {
      val && handleUnlinkDatasource();
    }
  };
  const handleDataSourceUnlink = (item) => {
    setConfirmId(2); // unlink datasource
    setUnlinkItem(item);
    setMessageConfirmation(t("Unlinkdatasourceconfirmation.label"));
    setShow(true);
  };
  const handleUnlinkDatasource = () => {
    let type = "unlink";
    handleDatasourceLink(type, unlinkItem?.id, unlinkItem?.riskDataSource?.datasourceId);
  }
  return (
    <>
      {riskParams?.map((item) => (
        <div className="card Risk_config_parameter_card" key={item.id}>
          <div className="card-body px-2 py-1">
            <div className="row m-0">
              <div className="col-lg-12 p-0">
                <div className="row m-0">
                  <div className="col-lg-2 p-2">
                    <h6 className="mb-0 me-2 Risk_config_parameter_card_head">{item.name}</h6>
                  </div>
                  <div className="col-lg-2 p-2">
                    <ul className="cursor">
                      <li>
                        <button
                          type="button"
                          className="mb-0 border-0 bg-transparent p-0 text-start"
                          onClick={() => handleChildExpand(item.id)}
                          aria-label={t("RiskParameter.expandChildren.label") || `Expand children for ${item.name}`}
                        >
                          <h6 className="mb-0">
                            {item.children ? item.children.length : 0}
                          </h6>
                        </button>
                      </li>
                      <li>
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t("ViewChildRiskParametersTooltip.label")
                          )}
                        >
                          <span>
                            <BiGitMerge
                              onClick={() => handleChildExpand(item.id)}
                            />
                          </span>
                        </OverlayTrigger>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-2 p-2">
                    <ul>
                      <li>{t("Maxscore.label")}</li>
                      <li>
                        <h6 className="mb-0">{item.maxScore}</h6>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-2 p-2">
                    <ul>
                      <li>{t("Weightage.label")}</li>
                      <li>
                        <h6 className="mb-0">
                          {item.weightage ? item.weightage + "%" : ""}
                        </h6>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4 p-2">
                    {item.children && !data.roles.includes("SUPPLIER_ADMIN") ? (
                      ""
                    ) : (
                      <>
                        <ul>
                          <OverlayTrigger
                            placement="top"
                            overlay={Utils.renderTooltip(
                              item.riskDataSource
                                ? t("Parameterlinked.label") +
                                " " +
                                //  item.riskDataSource.dataSourceType+" - '"+
                                item.riskDataSource.name
                                : t("Nodatasourcelinked.label")
                            )}
                          >
                            <li>

                              {item.riskDataSource
                                ? t("Datasourcelinked.label")
                                : t("Nodatasourcelinked.label")}
                              <a className="ms-2" href="#" onClick={() =>
                                handleDataSource(
                                  item.id,
                                  item.riskDataSource?.id
                                )
                              }>
                                <FiLink2 />
                              </a>
                            </li>


                          </OverlayTrigger>

                          {item.riskDataSource && (

                            <OverlayTrigger
                              placement="top"
                              overlay={Utils.renderTooltip(
                                t("Unlinkdatasource.label")
                              )}
                            >
                              <li>
                                <a className=" ms-2 cursor" href="#"
                                  onClick={() => handleDataSourceUnlink(item)}>
                                  <FiDelete />
                                </a>
                              </li>

                            </OverlayTrigger>


                          )}

                        </ul>


                      </>
                    )}
                  </div>
                </div>

                <div className="row m-0">
                  <div className="col-lg-12 px-2 py-1">
                    {t("RiskCategories.label")}
                  </div>
                  <div className="col-lg-12 p-0">
                    <div className="row m-0">
                      {item?.resultConfigs?.map((categ) => (
                        <div className="col-lg-2 px-2 py-1" key={categ.id}>
                          <ul>
                            <li>
                              <span style={{ color: categ.colorCode }}>
                                {categ.resultType}
                              </span>
                            </li>
                            <li>
                              <h6 className="mb-0">
                                {categ.minScore}-{categ.maxScore}
                              </h6>
                            </li>
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="edit_btn-absolute">
              {
                item.mandatory === true ? (
                ""
              ) : (
                <Dropdown>
                  <Dropdown.Toggle variant="blank_outline" id="dropdown-basic">
                    <BiDotsHorizontalRounded />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      href="#"
                      onClick={() => editRiskParam(item.id)}
                    >
                      <BiPencil /> {t("Edit.label")}
                    </Dropdown.Item>
                    <DropdownItem onClick={() => deleteRiskParam(item)}>
                      <BiTrash /> {t("Delete.label")}
                    </DropdownItem>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </div>
        </div>
      ))}
      {/* )} */}
      {show && (
        <ConfirmationModal
          modalShow={true}
          messageText={messageConfirmation}
          callbackModal={handleCallbackonfirmation}
          id={confirmId}
          confirmBtn={t("Yes.label")}
          CancelBtn={t("No.label")}
        />
      )}
    </>
  );
}
RiskParameter.propTypes = {
  riskParams: PropTypes.array.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleChild: PropTypes.func.isRequired,
};

export default withTranslation()(RiskParameter);
